import React from 'react';
import { Skeleton } from 'antd';
import { Space, Text } from '@g2u/ui-kit';
import styles from '../service-summary.module.scss';

type Detail = {
  key: string;
  value: string | React.ReactNode;
};

type SectionProps = {
  title: string;
  details: Detail[];
  actionButtons?: React.ReactElement[];
  isDanger?: boolean;
  isLoading?: boolean;
};

export const SummarySection = (props: SectionProps) => {
  const { title, details, actionButtons, isDanger, isLoading } = props;
  return (
    <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Large}>
      <Space.$ direction={Space.Direction.Vertical} size={Space.Size.ExtraSmall}>
        <Text.$ strong size={Text.Size.LG} type={isDanger ? 'danger' : undefined}>
          {title}
        </Text.$>
        {isLoading ? (
          <Skeleton className={styles.loader} />
        ) : (
          <div className={styles.splitColumns}>
            {details.map(
              (detail, index) =>
                detail.value && (
                  <React.Fragment key={index}>
                    <Text.$>{detail.key}:</Text.$>
                    <Text.$ className={styles.columnValue}>{detail.value}</Text.$>
                  </React.Fragment>
                ),
            )}
          </div>
        )}
      </Space.$>
      {!isLoading && (
        <Space.$ align={Space.Align.End} direction={Space.Direction.Vertical} size={Space.Size.ExtraLarge}>
          <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Small}>
            {actionButtons}
          </Space.$>
        </Space.$>
      )}
    </Space.$>
  );
};
